import React from 'react';

const Introduction = () => {
  return (
    <section className="text-center mb-20 md:mb-28">
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-6">
        <span className="xl:inline">Unlock Hidden Value in</span>{' '}
        <span className="text-sky-400 xl:inline">Every</span>{' '}
        <span className="xl:inline">Page</span>
      </h1>
      <p className="mt-6 max-w-3xl mx-auto text-lg sm:text-xl text-gray-400">
        Data Revival is a unique AI end-to-end data structuring and retrieval system for chemical archives, giving you unprecedented, contextual access to all your complex data sources.
      </p>
    </section>
  );
};

export default Introduction;